const clearLocalStorage = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('permission');
  localStorage.removeItem('allDiv');
  localStorage.removeItem('defaultDiv');
  localStorage.removeItem('aws_credentials');
};

export default clearLocalStorage;
